import { useAnalytics } from '@lower-financial/analytics/src/useAnalytics';
import { DidYouKnow, HighlightedText } from '@lightspeed/components/shared/banners/did-you-know';
import { Testimonial } from '@lightspeed/components/ui/molecules/testimonial';
import { CardToggleLayout } from '@lightspeed/components/shared/card-toggle-screen-layout/card-toggle-layout';
import { TestimonialSidebar } from '@lightspeed/components/shared/sidebars/testimonial-sidebar';

const options = [
  {
    icon: '👩‍💼',
    label: 'Yes, I have an agent.',
    value: true,
  },
  {
    icon: '👀',
    label: 'No, I’m browsing solo.',
    value: false,
  },
] as const;

const WorkingWithAgentDidYouKnow = () => (
  <DidYouKnow>
    The seller typically pays the commissions for both
    their <HighlightedText>real estate agent</HighlightedText> and the buyer’s.
  </DidYouKnow>
);

export const WorkingWithAgent = () => {
  const pageTitle = 'purchase_working_with_agent';
  const fireAnalyticsEvent = useAnalytics(pageTitle);

  return (
    <CardToggleLayout
      title={'Are you working with a real estate agent?'}
      subtitle={<>Teamwork makes the dream work. 🤝</>}
      mortgageApplicationField={'hasRealEstateAgent'}
      fireAnalyticsEvent={fireAnalyticsEvent}
      cardOptions={options}
      mobileBanner={<WorkingWithAgentDidYouKnow />}
      desktopSidebar={(
        <TestimonialSidebar
          testimonial={(
            <Testimonial
              title={'Would recommend to anyone considering purchasing'}
              content={'I cannot recommend Lower highly enough! From start to finish, their team made the home-buying process smooth, stress-free, and even enjoyable. As a first-time homebuyer, I had a lot of questions and uncertainties, but Lower was there every step of the way with clear explanations, prompt responses, and genuine support.'}
              author={'Joshua O’Shea'}
            />
          )}
          banner={<WorkingWithAgentDidYouKnow />}
        />
      )}
    />
  );
};
